export enum LoadingState {
  Loading,
  Loaded,
  Error,
}
